<template>
<div class="form-body">
  <div class="row">
    <div class="form-holder">
      <div class="form-content">
        <div class="form-items"  style="margin-top: 2%;">
          <div>
          <div class="form-row newDesign" style="width: 100%" v-if="successmsg !=''">
            <span class="logo" style="width: 100%;" v-html="logos"></span>
            <span class="logo" style="width: 100%;" v-html="REGISTERATION_SUCCESS_ICON"></span><br>
              <p class="lead success-text-align" style="width: 100%;font-size:20px;color:#141414;line-height: 23px;text-align: center;"><strong>{{successmsg}}!!!</strong></p>
              <br><br>
          </div>
          <div class="form-row newDesign container" style="width: 100% !important;" v-if="successmsg ==''">
            <span class="logo" style="width: 100%;"><img class="img" src="../assets/img/logo-black.png"></span>
            <div class="col-md-12">
              <div class="box">
                <div class="box-body">
                  <h4 class="box-title">Set Availability</h4>
                    <div class="setavailability">
                        <datetime
                          v-model="availability"
                          format="dd-MMM-yyyy hh:mm a"
                          :min-datetime="minDatetime1"
                          :minute-step="30"
                          type="datetime"
                          :value-zone="timezone"
                          :zone="timezone"
                          use12-hour
                          placeholder="Select Date *"
                        >
                        </datetime>
                    </div>
                </div>
                <div v-if="successmsg == ''" class="box-footer clearfix" style="background-color: #F5F5F5;">
                  <button class="btn btn-success editbtn mr-2" type="button" @click="setAvailability()" style="border-radius: 0px;">
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import * as Cookies from 'js-cookie'
import { REGISTERATION_SUCCESS, logo } from '../shared/svg'
import axios from 'axios'
import { BaseURL } from '../shared/classes'
// import { logo } from '../shared/svg'
// import momentsone from 'moment-timezone'
// import moment from 'moment'
// import router from '../router/index'
import momentsone from 'moment-timezone'
import moment from 'moment'
const timezoneList = [
  { id: 0, name: 'IST', fullName: 'Asia/Kolkata' },
  { id: 1, name: 'IST', fullName: 'Asia/Calcutta' },
  { id: 2, name: 'EST', fullName: 'America/New_York' },
  { id: 3, name: 'GMT', fullName: 'Europe/London' },
  { id: 4, name: 'CST', fullName: 'America/Chicago' },
  { id: 5, name: 'PST', fullName: 'America/Los_Angeles' },
  { id: 6, name: 'HST', fullName: 'Pacific/Honolulu' },
  { id: 7, name: 'AHST', fullName: 'America/Anchorage' }
]
export default {
  data () {
    return {
      REGISTERATION_SUCCESS_ICON: REGISTERATION_SUCCESS,
      logos: logo,
      minDatetime1: '',
      BaseURL: BaseURL,
      availability: '',
      timezone: momentsone.tz.guess(),
      timezonetype: '',
      scheduleId: '',
      successmsg: '',
      data: []
    }
  },
  mounted () {
    var d = new Date()
    var day = this.addZero(d.getDate())
    var month = this.addZero(d.getMonth() + 1)
    var year = this.addZero(d.getFullYear())
    // var hr = this.addZero(d.getHours())
    // var min = this.addZero(d.getMinutes())
    // var sec = this.addZero(d.getSeconds())
    // this.minDatetime1 = year + '-' + month + '-' + day + ' ' + hr + ':' + min + ':' + sec
    this.minDatetime1 = year + '-' + month + '-' + day
    this.getscheduleDetails(this.$route.params.sid)
  },
  methods: {
    addZero (i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },
    getscheduleDetails (id) {
      const mainurl = '/dashboard/get_schedule_detail/' + id
      axios.get(`${this.BaseURL}${mainurl}`, this.config).then(response => {
        if (response.data.refer_tag !== 'self') {
          this.data = response.data.scheduleList[0]
        } else {
          this.data = response.data.scheduleList_self[0]
        }
        if (this.data.schedule_date != null) {
          this.successmsg = 'Availability has been set already'
        }
      }).catch(e => {
        console.log(e)
      })
    },
    setAvailability () {
      var scheduleDate = moment(this.availability).format('yyyy-MM-DD')
      var scheduleStartTime = moment(this.availability).format('HH:mm:ss')
      var scheduleEndTime = moment(this.availability).add(1, 'hours').format('HH:mm:ss')
      var startDatetime = moment(this.availability).format('yyyy-MM-DD HH:mm:ss')
      var endDatetime = moment(this.availability).add(1, 'hours').format('yyyy-MM-DD HH:mm:ss')
      for (let i = 0; i < timezoneList.length; i++) {
        if (timezoneList[i].fullName === this.timezone) {
          this.timezonetype = timezoneList[i].name
        }
      }
      this.mainurl = '/dashboard/add_schedule_availability'
      var formData = {
        post_id: this.$route.params.pid,
        schedule_id: this.$route.params.sid,
        schedule_date: scheduleDate,
        schedule_end_time: scheduleEndTime,
        schedule_start_time: scheduleStartTime,
        start_datetime: startDatetime,
        end_datetime: endDatetime,
        schedule_org_timezone: '',
        schedule_candidate_timezone: this.timezonetype,
        schedule_timezone: this.timezonetype
      }
      axios.post(BaseURL + this.mainurl, {
        formData: formData
      }, this.config).then(response => {
        if (response.data.message === 'success') {
          this.$awn.success('Availability set successfully')
          this.successmsg = 'Availability set successfully'
        } else {
          this.$awn.success(response.data.message)
          this.successmsg = response.data.message
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>

<style scoped>
.passwardcompare {
  margin-top: 9px !important;
}
.img {
    width: 30% !important;
    margin-bottom: 15px;
}
.pwd_info {
  float: left;
  font-size: 12px;
  padding-bottom: 11px;
  color: red;
  margin-top: 0px;
}

.pwd_info_float_right {
  float: right;
  font-size: 12px;
  padding-bottom: 11px;
  color: #5BAD2B;
  /* cursor: pointer; */
  margin-top: -10px;
}

.pading_____zero {
  margin-bottom: 2px !important;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}

.form-holder {
  margin-left: 0px;
}

.login-policy-footer {
  width: 31%;
}

.progressbar {
  height: 5px !important;
  background: #e6e6e6;
}

ul {
  padding: 0px;
}

span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 0.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 7px;
}

.register____user__type {
  color: #000000;
  width: 44%;
  margin-left: 3%;
  margin-right: 3%;
  margin-bottom: 17px !important;
  cursor: pointer;
}

.progress_____round {
  border: 1px solid #5bad2b;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #5bad2b;
  font-weight: bold;
}

.progress_____round____hidden {
  border: 1px solid #bbb4b4;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #bbb4b4;
  font-weight: bold;
}
.form-content {
    width: auto;
}
.box {
  border-top: 0px solid #d2d6de;
  border-radius: 0px;
}
.form-content form {
    margin-bottom: 30px;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
}
.box-header .box-title {
    display: inline-block;
    font-size: 16px;
    margin: 0;
    line-height: 1;
    color:black;
}
.form-content .form-items {
    max-width: 540px;
}
html {
  height: 100% !important;
}
.form-content {
  background-color: #F5F5F5 !important;
}
.form-body {
  background-color: #F5F5F5 !important;
}
input {
  background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #DCDCDC;
}
.color-g {
  color: #5bad2b;
}
.setavailability {
    margin: 30px;
}
.logo-size {
  width: 50%;
}
.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-content {
    width: 100%;
}
.form-content p {
  line-height: 5px;
}
</style>
